module.exports = __webpack_public_path__ + "static/media/largier.e7b1aa81.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/res/images/largier.mp4
// module id = 988
// module chunks = 0